import React from "react";
import FormComponent from "./Components/Form";
import Database from '../../../../../../Dream Korea/web/src/Constant/database.json'
import { slugs } from "../../../../../../Dream Korea/web/src/Constant/slugs";
import ExamData from './Components/examData.json'

export default function NewCourse() {
  const FetchData = Database.paid_courses;
  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>New Course</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / <a href={slugs.all_course}>All Courses</a>
        </div>
      </div>
      <FormComponent
        FetchData={FetchData}
        db_slug={slugs.db_slug_course}
        webSlug={slugs.course_details}
      />
    </div>
  )
}